import React from "react"

import { ProjectPhaseChip } from "entities/projects/ui/project-phase-chip/ProjectPhaseChip"
import { ProjectRoleChip } from "entities/projects/ui/project-role-chip/ProjectRoleChip"
import { ProjectCard } from "features/project-management/ui/project-card/ProjectCard"

export const ProjectHeaderLoader = React.memo(() => {
  return (
    <ProjectCard isLoading className="card--elevated project-card--header">
      <ProjectCard.Image />
      <ProjectCard.Title />
      <ProjectCard.Chips>
        <ProjectPhaseChip phase={null} isLoading />
        <ProjectRoleChip teamRole={null} isLoading />
      </ProjectCard.Chips>
      <ProjectCard.Body />
    </ProjectCard>
  )
})
